<template>
  <div style="background: #fff;min-height: 600px">
    <div class="evaluationPeport_main" v-if="reportId" >
      <div class="title">
        {{user.name}}生涯测评报告
      </div>
     <div v-if="version==1">
        <div>
        <div class="partTitle">人格特性</div>
        <keep-alive>
          <Rgtx v-if="reportId" :reportId="reportId"></Rgtx>
        </keep-alive>
      </div>
      <div>
        <div class="partTitle">智能水平</div>
        <Rzqn v-if="reportId" :reportId="reportId"></Rzqn>
      </div>
      <div>
        <div class="partTitle">兴趣倾向</div>
        <Xqqx v-if="reportId" :reportId="reportId"></Xqqx>
      </div>
      <div>
        <div class="partTitle">职业价值观</div>
        <Zysy v-if="reportId" :reportId="reportId"></Zysy>
      </div>
      <div>
        <div class="partTitle">心理适应性</div>
        <Xljk v-if="reportId" :reportId="reportId"></Xljk>
      </div>
     </div>
     <div v-if="version==2">
        <div>
        <div class="partTitle">人格特性</div>
        <keep-alive>
           <Rgtx2 :mbti="mbti"></Rgtx2>
        </keep-alive>
      </div>
      <div>
        <div class="partTitle">智能水平</div>
        <keep-alive>
         <Znsp2 :intelligent="intelligent"></Znsp2>
        </keep-alive>
      </div>
      <div>
        <div class="partTitle">兴趣倾向</div>
        <keep-alive>
           <Xqqx2 :hobby="hobby" :radarChart="radarChart"></Xqqx2>
        </keep-alive>
      </div>
      <div>
        <div class="partTitle">职业价值观</div>
        <keep-alive>
           <Zyjzg2 :profession="profession"></Zyjzg2>
        </keep-alive>
      </div>
      <div>
        <div class="partTitle">心理适应性</div>
        <keep-alive>
           <Xlsyx2 :mind="mind" :result='result'></Xlsyx2>
        </keep-alive>
      </div>
     </div>
      <!-- <div class="evaluation_button" @click="$router.go(-1)" style="margin-top: 30px">
        返回
      </div> -->
    </div>
    <div v-else class="noContent">
      <NoContent></NoContent>
    </div>
  </div>
</template>
<script>
import Rgtx from './components/evalutionReport/rgtx'
import Rzqn from './components/evalutionReport/rzqn'
import Xqqx from './components/evalutionReport/xqqx'
import Zysy from './components/evalutionReport/zysy'
import Xljk from './components/evalutionReport/xljk'
import NoContent from '@/components/NoContent.vue'


//新
import Rgtx2 from './components/evalutionReport2/rgtx'
import Znsp2 from './components/evalutionReport2/znsp'
import Xqqx2 from './components/evalutionReport2/xqqx'
import Zyjzg2 from './components/evalutionReport2/zyjzg'
import Xlsyx2 from './components/evalutionReport2/xlsyx'

export default {
  name: "evaluationReport",
  props:['componentId'],
  data(){
    return {
       reportId:'',
      version:'',
      mbti:{},
      intelligent:[],
      hobby:{},
      radarChart:[],
      radarValue:[],
      profession: {}, //职业倾向
      mind:{},
      result:[],
    }
  },
  computed:{
    user(){
      return this.$store.state.user
    },
  },
  components:{Rgtx,Rzqn,Xqqx,Zysy,Xljk,NoContent,Rgtx2,Znsp2,Xqqx2,Zyjzg2,Xlsyx2},
  methods:{
    getReportId(){
      this.$ajax.post(this.G_acapi + this.ports.student.student.studentMessage.careerReport.getCareerReportIdByStudentIdByStudent,{

      },{
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res=>{
        console.log(res)
        // if(res.data.code==2000){
        //   let reportId=res.data.data.reportId;
        //   if(this.reportId.length){
        //     if(this.reportId.length==0){
        //       return
        //     }
        //   }else{
        //     this.reportId=reportId
        //   }
        // }else{

        // }
        if(res.data.code==2000){
          console.log(res)
          this.version=res.data.data.career.version;
          this.reportId=res.data.data.career.reportId;
          // this.version=2;
          // this.reportId='02b4998babda49d58a0a7bb7c3c6211a';
          if(this.version == 2){
              this.getReportData(this.reportId)
          }
        }else{
        }
      })
    },
      judgeNewOld(){
      this.$ajax.post(this.G_acapi + this.ports.consultant.student.report.judge,{
        studentId:3038
      },{
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res=>{
        if(res.data.code==2000){
          console.log(res)
          this.version=res.data.data.career.version;
          this.reportId=res.data.data.career.reportId;
          // this.version=2;
          // this.reportId='02b4998babda49d58a0a7bb7c3c6211a';
          if(this.version == 2){
              this.getReportData(this.reportId)
          }
        }else{
        }
      })
    },
     getReportData(id){
      this.$ajax.post(this.G_capi + this.ports.consultant.student.report.newReportData,{
        reportId: id,
      },{
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res=>{
        if(res.data.code==2000){
          console.log(res)
          this.mbti = res.data.data.mbti; //人格特性
          this.intelligent = res.data.data.intelligent; //智能水平
          this.hobby = res.data.data.hobby; //兴趣倾向
          this.radarChart = res.data.data.hobby.radarChart
          this.threeYard = res.data.data.hobby.threeYard
            this.profession = res.data.data.profession; //职业价值观
          this.mind = res.data.data.mind; //心里适应性
          this.result = res.data.data.mind.result

        
          this.$nextTick(()=>{
            
           //  this.drawBagua(this.bgNewArr2);
          })
        }else{
        }
      })
    },
  }
  ,mounted() {
  //  console.log(this.$route.query.studentId)
    console.log(this.$store.state.user)
    //this.judgeNewOld()
   this.getReportId()
    // this.reportId='8bc82706dede4f92a7bad4546319c072'
  }
}
</script>

<style  lang="less" scoped>
.evaluationPeport_main{
  margin:0 auto;
  background: #fff;
  padding: 20px 85px  50px;
  .title{
    font-size: 32px;
    font-weight: bolder;
    line-height: 80px;
    text-align: center;
    color:#0094EA;
  }
  .partTitle{
    font-size: 20px;
    color:#2F2F2F;
    font-weight: bolder;
    padding: 30px 0 ;
  }
  .evaluation_button{
    width: 74px;
    margin: 0 auto;
    border-radius: 16px;
    text-align: center;
    line-height: 32px;
    font-size: 16px;
    cursor: pointer;
    background: #ECF8FE;
    color: #1EA2EE;
    border: 1px solid #76C6F4;
    padding: 0 20px;
    &:hover{
      background: #099BEF !important;
      color: #fff !important;
    }
  }


}
</style>